import gql from "graphql-tag";

export const GET_TEMPLATES = gql`
    query {
        rows: timeline_templates {
            id
            name
            data
        }
    }
`;

export const GET_TEMPLATE = gql`
    query getTemplate($id: Int!) {
        row: timeline_templates_by_pk(id: $id) {
            id
            name
            data
        }
    }
`;

export const CREATE_TEMPLATE = gql`
    mutation addTemplate($data: timeline_templates_insert_input!) {
        row: insert_timeline_templates_one(object: $data) {
            id
            name
            data
        }
    }
`;

export const UPDATE_TEMPLATE = gql`
    mutation updateTemplate($id: Int!, $data: timeline_templates_set_input) {
        row: update_timeline_templates_by_pk(pk_columns: {id: $id}, _set: $data) {
            id
            name
            data
        }
    }
`;

export const DELETE_TEMPLATE = gql`
    mutation deleteTemplate($id: Int!) {
        delete_timeline_templates_by_pk(id: $id) {
            id
        }
    }
`
